<div class="main">
  <div class="leftside">
    <img src="assets/LeftSideTriangles.svg" alt="">
  </div>
  <div class="rightside">
    <img src="assets/RightSideTriangles.svg" alt="">
  </div>
  <div class="section">
    <div class="center">
      <div class="logo">
        <img src="assets/SmartTruck-Logo-HalfWhite.svg" alt="">
      </div>
      <div class="card">
        <div class="background">
          <div class="barLine"></div>
          <img src="assets/User-Circle.svg" class="userIcon" alt="">
        </div>
        <div class="forgot">
          Forgot Password
        </div>
        <div class="form">
          <i class="material-icons matIcon">email</i>
          <input type="text" [(ngModel)]="email.email_id" placeholder="EMAIL" class="formField" autocomplete="false" (keyup.enter)="submit()">
          
          <div class="buttons">
            <div class="submitButton" [routerLink]="['/login']" style="background-color: #747474;">
              Back
            </div>
            <div class="submitButton" (click)="submit();">
              Submit
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
